import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleFilled } from "@ant-design/icons";
import { Button, Modal, theme } from "antd";
import { __, _i } from "../../../../utils/i18n.js";
const CancellationConfirmedModal = ({ effectiveEndDateLabel, onClose })=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs(Modal, {
        open: true,
        title: /*#__PURE__*/ _jsxs("div", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: 8,
                paddingTop: 4
            },
            children: [
                /*#__PURE__*/ _jsx(CheckCircleFilled, {
                    style: {
                        color: token.colorSuccess,
                        fontSize: 20
                    }
                }),
                /*#__PURE__*/ _jsx("span", {
                    style: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: token.colorTextHeading
                    },
                    children: __("Cancellation confirmed")
                })
            ]
        }),
        onCancel: onClose,
        footer: /*#__PURE__*/ _jsx("div", {
            style: {
                display: "flex",
                justifyContent: "flex-end"
            },
            children: /*#__PURE__*/ _jsx(Button, {
                type: "primary",
                onClick: onClose,
                children: __("Close")
            })
        }),
        destroyOnClose: true,
        width: 640,
        children: [
            /*#__PURE__*/ _jsx("p", {
                style: {
                    marginTop: 0,
                    fontSize: 14,
                    lineHeight: 1.6,
                    color: token.colorText
                },
                children: __("Thank you for being a customer. We're genuinely grateful for the time you trusted us with our product, and we hope it served you well.")
            }),
            /*#__PURE__*/ _jsx("p", {
                style: {
                    marginTop: 12,
                    fontSize: 14,
                    lineHeight: 1.6,
                    color: token.colorText
                },
                children: _i(__("The cancellation receipt is on its way to your inbox. {{strong}}Your subscription stays active until %s.{{/strong}}", effectiveEndDateLabel), {
                    strong: /*#__PURE__*/ _jsx("strong", {
                        style: {
                            color: token.colorTextHeading
                        }
                    })
                })
            })
        ]
    });
};
export { CancellationConfirmedModal };
